<template>
  <div class="wrapper">
    <div class="look-nav">
      <div class="top-select">
        <div style="margin-right: 1vw">
          <DropDown :content="warehouseTitle" :items="warehouse" @sendInfo = "showInfoW"></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown :content="buildingTitle" :items="building" @sendInfo = "showInfoB"></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown :content="floorTitle" :items="floor" @sendInfo = "showInfoF"></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown :content="areaTitle" :items="area" @sendInfo = "showInfoA"></DropDown>
        </div>
        <div class="query button" @click="functionA">查询</div>
      </div>
    </div>
    <div class="equipment-content">
      <div class="equipment-operation">
        <div class="two-font-wrapper" style="margin-right: 1vw" @click="showAddEquipment"><div class="icon-font">&#xe605;</div>添加</div>
        <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
      </div>
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 10%">
              <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
            </div>
            <div class="detail-item" style="width: 10%">设备编号</div>
            <div class="detail-item" style="width: 20%">设备名称</div>
            <div class="detail-item" style="width: 20%">位置</div>
            <div class="detail-item" style="width: 10%">管理人</div>
            <div class="detail-item" style="width: 10%">状态</div>
            <div class="detail-item" style="width: 20%">操作</div>
          </div>
          <div class="detail-content">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
              <div class="detail-item" style="width: 10%" >
                <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
              </div>
              <div class="detail-item" style="width: 10%">{{data.codeNum}}</div>
              <div class="detail-item" style="width: 20%">{{data.name}}</div>
              <div class="detail-item" style="width: 20%">{{data.gatherSite}}</div>
              <div class="detail-item" style="width: 10%">{{data.custodian}}</div>
              <div class="detail-item" style="width: 10%" :class="{'color-red': data.status === '02'}">{{data.status === '02' ? '异常' : '正常'}}</div>
              <div class="detail-item" style="width: 20%">
                <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="toEquipmentDetail(data.id)">查看</div>
                <div class="detail-btn item-history" style="margin-right: 0.5vw" @click="updateEquipmentStatus(data)">更新状态</div>
                <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="alert-box" v-if="show">
            <div class="alert-content">
              <div class="alert-content-title">删除提醒</div>
              <div class="alert-content-msg">是否确认删除选中数据?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelDelete">取消</div>
                <div class="btn-confirm button" @click="confirmDelete">确认</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="showAdd">
        <div class="alert-content" style="width: auto;padding: 1vw 2vw">
          <div class="alert-content-title">添加设备</div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column">
            <div class="house-list">
              <div class="input-contain" style="margin-right: 2vw">
                <div class="input-title">设备编号：</div>
                <div class="input-wrapper">
                  <input v-model="tableItem.codeNum" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">设备名称：</div>
                <div class="input-wrapper">
                  <input v-model="tableItem.name" placeholder=""/>
                </div>
              </div>
            </div>
            <div class="house-list">
              <div class="input-contain" style="margin-right: 2vw;z-index: 9999;position: relative">
                <div class="input-title" style="padding-left: 1.78vw">位置：</div>
                <LoadingTreeStack :moduleType="moduleType"  :content="tableItem.gatherSite" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">管理人：</div>
                <DropDownInput type="1" :items="custodianValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw;z-index: 1;position: relative">状态：</div>
              <DropDown :content="tableItem.status === '01' ? '正常' : '异常'" :items="statusData" v-on:sendInfo = "showInfoStatus"></DropDown>
            </div>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelAdd">取消</div>
            <div class="btn-confirm button" @click="confirmAdd">确认</div>
          </div>
        </div>
      </div>
    </transition>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import TreeSingle from '../../../components/TreeSingle.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import DropDownInput from '../../../components/DropDownInput.vue'
import {warehouseNode, addEquipment, queryEquipment, delEquipment, bathDelEquipment, updateStatus} from '../../../api/basic'
import {userList} from '../../../api/system'
import {NonChineseInput, noEmpty} from '../../../tools/methods'
export default {
  name: 'Equipment',
  components: { DropDown, LoadingTreeStack, TreeSingle, DropDownInput },
  data () {
    return {
      showAdd: false,
      show: false,
      all: false,
      idList: [],
      id: '',
      type: 0,
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      warehouseTitle: '请选择仓库',
      buildingTitle: '请选择楼号',
      floorTitle: '请选择层号',
      areaTitle: '请选择区号',
      siteId: '',
      siteType: '',
      status: '',
      statusData: [
        {name: '正常', value: '01'},
        {name: '异常', value: '02'}
      ],
      moduleType: '-1',
      treeId: '',
      tableItem: {
        codeNum: '',
        custodian: '',
        custodian_id: '',
        gatherSite: '',
        id: '',
        name: '',
        siteId: '',
        siteRoute: '',
        siteType: '',
        status: '01'
      },
      custodianData: [],
      loading: true,
      page: 1,
      rows: 9,
      total: '',
      tableData: [],
      custodianValue: []
    }
  },
  created () {
    let body = {
      warehouseNodeId: '',
      warehouseNodeType: '01'
    }
    warehouseNode(body).then(res => {
      console.log(res)
      this.warehouse = res.data
      this.handleSearch(1)
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    showInfo: function (data) {
      this.tableItem.custodian = data.name
      this.tableItem.custodian_id = data.nodeId
      console.log(data)
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    functionA: function () {
      this.handleSearch(1)
    },
    showInfoW: function (data) {
      this.warehouseTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '02'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.building = res.data
        this.buildingTitle = '请选择楼号'
        this.floor = []
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '03'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.floor = res.data
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoF: function (data) {
      this.floorTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '04'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.area = res.data
        this.areaTitle = '请选择区号'
        this.stack = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoA: function (data) {
      this.areaTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      console.log(data)
    },
    showInfoStatus: function (data) {
      this.tableItem.status = data.value
    },
    showDropInfo: function (data) {
      console.log(data)
      this.tableItem.gatherSite = data.name
      this.tableItem.siteId = data.id
      this.tableItem.siteType = data.siteType
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
        let body = {
          equipmentId: this.id
        }
        delEquipment(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log(this.idList)
        let body = {
          equipmentIdLs: this.idList.join()
        }
        bathDelEquipment(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    toEquipmentDetail: function (id) {
      this.$router.push({
        path: '/equipmentDetail',
        query: {
          index: '3',
          equipmentId: id
        }
      })
    },
    showAddEquipment: function () {
      this.showAdd = true
      this.handleSearchValue()
      this.tableItem = {
        codeNum: '',
        custodian: '',
        custodian_id: '',
        gatherSite: '',
        id: '',
        name: '',
        siteId: '',
        siteRoute: '',
        siteType: '',
        status: '01'
      }
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      console.log(this.tableItem)
      if (
        noEmpty(this.tableItem.name, '请输入设备名称', '') &&
        NonChineseInput(this.tableItem.codeNum, '请输入设备编号', '仓库代码不可输入中文', '') &&
        noEmpty(this.tableItem.gatherSite, '请选择位置', '') &&
        noEmpty(this.tableItem.custodian, '请选择管理人员', '')
      ) {
        addEquipment(this.tableItem).then(res => {
          console.log(res)
          this.showAdd = false
          this.handleSearch(1)
          this.$message({
            message: '添加成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
        }).catch(err => {
          console.log(err)
        })
      }
    },
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      let body = {
        status: this.status,
        page: this.page,
        rows: this.rows,
        siteId: this.siteId,
        siteType: this.siteType
      }
      queryEquipment(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    updateEquipmentStatus: function (data) {
      let body = {
        equipmentId: data.id,
        status: data.status === '01' ? '02' : '01'
      }
      updateStatus(body).then(res => {
        this.$message({
          message: '更新成功!',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
        this.handleSearch()
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "./Equipment.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/equipment/Equipment.vue